let Fields = require('sma.fs/surveys/fields');
let Class = require('sma.fs/chide/class');
let chide = require('sma.fs/chide/ui');
let Option = require('sma.fs/surveys/options').Option;
let ElementSearch = require('sma.admin/components/element_search');
let block = require('sma.common/block');


let guideStarSchemaTree = [
	{'identifier': 'also_known_as', 'name': gettext('Also known as')},
	{'children': [{'identifier': 'affiliation', 'name': gettext('Affiliation')},
		{'identifier': 'bio', 'name': gettext('Bio'), 'isTextArea': true},
		{'identifier': 'compensation', 'name': gettext('Compensation')},
		{'identifier': 'email', 'name': gettext('Email')},
		{'identifier': 'end_month', 'name': gettext('End month')},
		{'identifier': 'end_year', 'name': gettext('End year')},
		{'identifier': 'first_name', 'name': gettext('First name')},
		{'identifier': 'last_name', 'name': gettext('Last name')},
		{'identifier': 'middle_name', 'name': gettext('Middle name')},
		{'identifier': 'picture', 'name': gettext('Picture')},
		{'identifier': 'prefix', 'name': gettext('Prefix')},
		{'identifier': 'start_month', 'name': gettext('Start month')},
		{'identifier': 'start_year', 'name': gettext('Start year')},
		{'identifier': 'status', 'name': gettext('Status')},
		{'identifier': 'suffix', 'name': gettext('Suffix')},
		{'identifier': 'title', 'name': gettext('Title')}],
		'identifier': 'board_chair',
		'name': gettext('Board chair')},
	{'children': [{'identifier': 'affiliation', 'name': gettext('Affiliation')},
		{'identifier': 'bio', 'name': gettext('Bio'), 'isTextArea': true},
		{'identifier': 'compensation', 'name': gettext('Compensation')},
		{'identifier': 'email', 'name': gettext('Email')},
		{'identifier': 'end_month', 'name': gettext('End month')},
		{'identifier': 'end_year', 'name': gettext('End year')},
		{'identifier': 'first_name', 'name': gettext('First name')},
		{'identifier': 'last_name', 'name': gettext('Last name')},
		{'identifier': 'middle_name', 'name': gettext('Middle name')},
		{'identifier': 'picture', 'name': gettext('Picture')},
		{'identifier': 'prefix', 'name': gettext('Prefix')},
		{'identifier': 'start_month', 'name': gettext('Start month')},
		{'identifier': 'start_year', 'name': gettext('Start year')},
		{'identifier': 'status', 'name': gettext('Status')},
		{'identifier': 'suffix', 'name': gettext('Suffix')},
		{'identifier': 'title', 'name': gettext('Title')}],
		'identifier': 'board_co_chair',
		'name': gettext('Board co-chair')},
	{'children': [{'identifier': 'board_composition', 'name': gettext('Board composition')},
		{'identifier': 'board_orientation_and_education', 'name': gettext('Board orientation and education')},
		{'identifier': 'board_performance', 'name': gettext('Board performance')},
		{'identifier': 'ceo_oversight', 'name': gettext('CEO oversight')},
		{'identifier': 'ethnics_and_transparency', 'name': gettext('Ethics and transparency')}],
		'identifier': 'board_source',
		'name': gettext('Board source')},
	{'identifier': 'bridge_id', 'name': gettext('Bridge ID')},
	{'children': [{'identifier': 'affiliation', 'name': gettext('Affiliation')},
		{'identifier': 'bio', 'name': gettext('Bio'), 'isTextArea': true},
		{'identifier': 'compensation', 'name': gettext('Compensation')},
		{'identifier': 'email', 'name': gettext('Email')},
		{'identifier': 'end_month', 'name': gettext('End month')},
		{'identifier': 'end_year', 'name': gettext('End year')},
		{'identifier': 'first_name', 'name': gettext('First name')},
		{'identifier': 'last_name', 'name': gettext('Last name')},
		{'identifier': 'middle_name', 'name': gettext('Middle name')},
		{'identifier': 'picture', 'name': gettext('Picture')},
		{'identifier': 'prefix', 'name': gettext('Prefix')},
		{'identifier': 'start_month', 'name': gettext('Start month')},
		{'identifier': 'start_year', 'name': gettext('Start year')},
		{'identifier': 'status', 'name': gettext('Status')},
		{'identifier': 'suffix', 'name': gettext('Suffix')},
		{'identifier': 'title', 'name': gettext('Title')}],
		'identifier': 'co_executive_director',
		'name': gettext('Co-executive director')},
	{'children': [{'identifier': 'diversity_committee', 'name': gettext('Diversity committee')},
		{'identifier': 'diversity_manager', 'name': gettext('Diversity manager')},
		{'identifier': 'diversity_manager_full_time', 'name': gettext('Diversity manager full-time')},
		{'identifier': 'diversity_plan', 'name': gettext('Diversity plan')},
		{'identifier': 'support_diversity_other_methods', 'name': gettext('Support diversity by other methods')},
		{'identifier': 'track_age_of_staff', 'name': gettext('Track age of staff')},
		{'identifier': 'track_diversity_of_vendors', 'name': gettext('Track diversity of vendors')},
		{'identifier': 'track_income_levels', 'name': gettext('Track income levels')},
		{'identifier': 'track_retention', 'name': gettext('Track retention')}],
		'identifier': 'demographics',
		'name': gettext('Demographics')},
	{'children': [{'children': [{'identifier': 'board_members', 'name': gettext('Board members')},
		{'identifier': 'senior_staff', 'name': gettext('Senior staff')},
		{'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time')},
		{'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time')},
		{'identifier': 'volunteers', 'name': gettext('Volunteers')}],
		'identifier': 'personWithDisability',
		'name': gettext('Person with disability')},
		{'children': [{'identifier': 'board_members', 'name': gettext('Board members')},
			{'identifier': 'senior_staff', 'name': gettext('Senior staff')},
			{'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time')},
			{'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time')},
			{'identifier': 'volunteers', 'name': gettext('Volunteers')}],
			'identifier': 'unknownOrDeclinedToState',
			'name': gettext('Unknown or declined to state')}],
		'identifier': 'demographics_by_disability',
		'name': gettext('Demographics by disability')},
	{'children': [{'children': [{'identifier': 'board_members', 'name': gettext('Board members')},
		{'identifier': 'senior_staff', 'name': gettext('Senior staff')},
		{'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time')},
		{'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time')},
		{'identifier': 'volunteers', 'name': gettext('Volunteers')}],
		'identifier': 'asianOrAsianAmerican',
		'name': gettext('Asian or Asian American')},
		{'children': [{'identifier': 'board_members', 'name': gettext('Board members')},
			{'identifier': 'senior_staff', 'name': gettext('Senior staff')},
			{'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time')},
			{'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time')},
			{'identifier': 'volunteers', 'name': gettext('Volunteers')}],
			'identifier': 'blackOrAfricanAmerican',
			'name': gettext('Black or African American')},
		{'children': [{'identifier': 'board_members', 'name': gettext('Board members')},
			{'identifier': 'senior_staff', 'name': gettext('Senior staff')},
			{'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time')},
			{'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time')},
			{'identifier': 'volunteers', 'name': gettext('Volunteers')}],
			'identifier': 'hispanicOrLatinoOrLatina',
			'name': gettext('Hispanic or Latino or Latina')},
		{'children': [{'identifier': 'board_members', 'name': gettext('Board members')},
			{'identifier': 'senior_staff', 'name': gettext('Senior staff')},
			{'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time')},
			{'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time')},
			{'identifier': 'volunteers', 'name': gettext('Volunteers')}],
			'identifier': 'multiRacialOrMultiEthnic',
			'name': gettext('Multi-racial or Multi-ethnic')},
		{'children': [{'identifier': 'board_members', 'name': gettext('Board members')},
			{'identifier': 'senior_staff', 'name': gettext('Senior staff')},
			{'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time')},
			{'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time')},
			{'identifier': 'volunteers', 'name': gettext('Volunteers')}],
			'identifier': 'nativeAmericanOrAmericanIndianOrAlaskaNativeOrNativeHawaiian',
			'name': gettext('Native American or American Indian or Alaska Native or Native Hawaiian')},
		{'children': [{'identifier': 'board_members', 'name': gettext('Board members')},
			{'identifier': 'senior_staff', 'name': gettext('Senior staff')},
			{'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time')},
			{'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time')},
			{'identifier': 'volunteers', 'name': gettext('Volunteers')}],
			'identifier': 'unknownOrDeclinedToState',
			'name': gettext('Unknown or declined to state')},
		{'children': [{'identifier': 'board_members', 'name': gettext('Board members')},
			{'identifier': 'senior_staff', 'name': gettext('Senior staff')},
			{'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time')},
			{'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time')},
			{'identifier': 'volunteers', 'name': gettext('Volunteers')}],
			'identifier': 'white',
			'name': gettext('White')}],
		'identifier': 'demographics_by_ethnicity',
		'name': gettext('Demographics by ethnicity')},
	{'children': [{'children': [{'identifier': 'board_members', 'name': gettext('Board members')},
		{'identifier': 'senior_staff', 'name': gettext('Senior staff')},
		{'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time')},
		{'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time')},
		{'identifier': 'volunteers', 'name': gettext('Volunteers')}],
		'identifier': 'female',
		'name': gettext('Female')},
		{'children': [{'identifier': 'board_members', 'name': gettext('Board members')},
			{'identifier': 'senior_staff', 'name': gettext('Senior staff')},
			{'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time')},
			{'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time')},
			{'identifier': 'volunteers', 'name': gettext('Volunteers')}],
			'identifier': 'male',
			'name': gettext('Male')},
		{'children': [{'identifier': 'board_members', 'name': gettext('Board members')},
			{'identifier': 'senior_staff', 'name': gettext('Senior staff')},
			{'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time')},
			{'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time')},
			{'identifier': 'volunteers', 'name': gettext('Volunteers')}],
			'identifier': 'transgenderOrUnspecifiedNonConforming',
			'name': gettext('Transgender or Unspecified or Non-conforming')},
		{'children': [{'identifier': 'board_members', 'name': gettext('Board members')},
			{'identifier': 'senior_staff', 'name': gettext('Senior staff')},
			{'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time')},
			{'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time')},
			{'identifier': 'volunteers', 'name': gettext('Volunteers')}],
			'identifier': 'unknownOrDeclinedToState',
			'name': gettext('Unknown or declined to state')}],
		'identifier': 'demographics_by_gender',
		'name': gettext('Demographics by gender')},
	{'children': [{'children': [{'identifier': 'board_members', 'name': gettext('Board members')},
		{'identifier': 'senior_staff', 'name': gettext('Senior staff')},
		{'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time')},
		{'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time')},
		{'identifier': 'volunteers', 'name': gettext('Volunteers')}],
		'identifier': 'lesbianGayBisexual',
		'name': gettext('Lesbian or Gay or Bisexual')},
		{'children': [{'identifier': 'board_members', 'name': gettext('Board members')},
			{'identifier': 'senior_staff', 'name': gettext('Senior staff')},
			{'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time')},
			{'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time')},
			{'identifier': 'volunteers', 'name': gettext('Volunteers')}],
			'identifier': 'unknownOrDeclinedToState',
			'name': gettext('Unknown or declined to state')}],
		'identifier': 'demographics_by_sexual_orientation',
		'name': gettext('Demographics by sexual orientation')},
	{'identifier': 'doing_business_as', 'name': gettext('Doing business as')},
	{'children': [{'identifier': 'affiliation', 'name': gettext('Affiliation')},
		{'identifier': 'bio', 'name': gettext('Bio'), 'isTextArea': true},
		{'identifier': 'compensation', 'name': gettext('Compensation')},
		{'identifier': 'email', 'name': gettext('Email')},
		{'identifier': 'end_month', 'name': gettext('End month')},
		{'identifier': 'end_year', 'name': gettext('End year')},
		{'identifier': 'first_name', 'name': gettext('First name')},
		{'identifier': 'last_name', 'name': gettext('Last name')},
		{'identifier': 'middle_name', 'name': gettext('Middle name')},
		{'identifier': 'picture', 'name': gettext('Picture')},
		{'identifier': 'prefix', 'name': gettext('Prefix')},
		{'identifier': 'start_month', 'name': gettext('Start month')},
		{'identifier': 'start_year', 'name': gettext('Start year')},
		{'identifier': 'status', 'name': gettext('Status')},
		{'identifier': 'suffix', 'name': gettext('Suffix')},
		{'identifier': 'title', 'name': gettext('Title')}],
		'identifier': 'executive_director',
		'name': gettext('Executive director')},
	{'identifier': 'fax', 'name': gettext('Fax')},
	{'identifier': 'funding_needs', 'name': gettext('Funding needs')},
	{'identifier': 'geographic_areas_served_narrative', 'name': gettext('Geographic areas served')},
	{'identifier': 'geographic_areas_served', 'name': gettext('Geographic areas served')},
	{'identifier': 'government_issued_id', 'name': gettext('Government issued ID')},
	{'identifier': 'government_issued_ruling_year', 'name': gettext('Government issued ruling year')},
	{'identifier': 'government_registered_name', 'name': gettext('Government registered name')},
	{'identifier': 'irs_509a_status', 'name': gettext('IRS 509a status')},
	{'identifier': 'irs_subsection_code', 'name': gettext('IRS subsection code')},
	{'identifier': 'form_990', 'name': gettext('Form 990')},
	{'identifier': 'impact_statement', 'name': gettext('Impact statement'), 'isTextArea': true},
	{'identifier': 'incorporation_year', 'name': gettext('Incorporation year')},
	{'children': [{'identifier': 'address_line_1', 'name': gettext('Address')},
		{'identifier': 'address_line_2', 'name': gettext('Address line 2')},
		{'identifier': 'city', 'name': gettext('City')},
		{'identifier': 'country_abbrev', 'name': gettext('Country')},
		{'identifier': 'postal_code', 'name': gettext('Postal code')},
		{'identifier': 'country_subdivision_abbrev_', 'name': gettext('State / Province')}],
		'identifier': 'international_address',
		'name': gettext('International address')},
	{'identifier': 'international_phone', 'name': gettext('International phone')},
	{'identifier': 'keywords', 'name': gettext("Keywords describing your organization's work")},
	{'identifier': 'logo_name', 'name': gettext('Logo name')},
	{'identifier': 'logo_path', 'name': gettext('Logo path')},
	{'identifier': 'notes', 'name': gettext('Notes')},
	{'identifier': 'organization_id', 'name': gettext('Organization ID')},
	{'identifier': 'organization_blog', 'name': gettext('Organization blog')},
	{'identifier': 'organization_email', 'name': gettext('Organization email')},
	{'identifier': 'mission_statement', 'name': gettext('Organization mission statement'), 'isTextArea': true},
	{'identifier': 'organization_website', 'name': gettext('Organization website')},
	{'identifier': 'participation_level', 'name': gettext('Participation level')},
	{'children': [{'identifier': 'address_line_1', 'name': gettext('Address')},
		{'identifier': 'address_line_2', 'name': gettext('Address line 2')},
		{'identifier': 'city', 'name': gettext('City')},
		{'identifier': 'country_abbrev', 'name': gettext('Country')},
		{'identifier': 'postal_code', 'name': gettext('Postal code')},
		{'identifier': 'country_subdivision_abbrev_', 'name': gettext('State / Province')}],
		'identifier': 'physical_address',
		'name': gettext('Physical address')},
	{'children': [{'identifier': 'address_line_1', 'name': gettext('Address')},
		{'identifier': 'address_line_2', 'name': gettext('Address line 2')},
		{'identifier': 'city', 'name': gettext('City')},
		{'identifier': 'country_abbrev', 'name': gettext('Country')},
		{'identifier': 'postal_code', 'name': gettext('Postal code')},
		{'identifier': 'country_subdivision_abbrev_', 'name': gettext('State / Province')}],
		'identifier': 'primary_address',
		'name': gettext('Primary address')},
	{'children': [{'identifier': 'affiliation', 'name': gettext('Affiliation')},
		{'identifier': 'bio', 'name': gettext('Bio'), 'isTextArea': true},
		{'identifier': 'compensation', 'name': gettext('Compensation')},
		{'identifier': 'email', 'name': gettext('Email')},
		{'identifier': 'end_month', 'name': gettext('End month')},
		{'identifier': 'end_year', 'name': gettext('End year')},
		{'identifier': 'first_name', 'name': gettext('First name')},
		{'identifier': 'last_name', 'name': gettext('Last name')},
		{'identifier': 'middle_name', 'name': gettext('Middle name')},
		{'identifier': 'picture', 'name': gettext('Picture')},
		{'identifier': 'prefix', 'name': gettext('Prefix')},
		{'identifier': 'start_month', 'name': gettext('Start month')},
		{'identifier': 'start_year', 'name': gettext('Start year')},
		{'identifier': 'status', 'name': gettext('Status')},
		{'identifier': 'suffix', 'name': gettext('Suffix')},
		{'identifier': 'title', 'name': gettext('Title')}],
		'identifier': 'primary_contact',
		'name': gettext('Primary contact')},
	{'identifier': 'primary_organization_name', 'name': gettext('Primary organization name')},
	{'identifier': 'primary_telephone', 'name': gettext('Primary telephone')},
	{'children': [{'identifier': 'facebook', 'name': gettext('Facebook')},
		{'identifier': 'flickr', 'name': gettext('Flickr')},
		{'identifier': 'foursquare', 'name': gettext('Foursquare')},
		{'identifier': 'google', 'name': gettext('Google')},
		{'identifier': 'instagram', 'name': gettext('Instagram')},
		{'identifier': 'linkedin', 'name': gettext('Linkedin')},
		{'identifier': 'pinterest', 'name': gettext('Pinterest')},
		{'identifier': 'tumblr', 'name': gettext('Tumblr')},
		{'identifier': 'twitter', 'name': gettext('Twitter')},
		{'identifier': 'vimeo', 'name': gettext('Vimeo')},
		{'identifier': 'youtube', 'name': gettext('Youtube')}],
		'identifier': 'social',
		'name': gettext('Social')},
	{'identifier': 'year_founded', 'name': gettext('Year founded')}
];

let GuideStarTextField = $.klass(Fields.TextField, {
	isGuideStar: true,
	isTextArea: false,
	defaultTitle: '',

	initialize: function ($super, info, editor) {
		info = info || {};
		$super(info, editor);
		let that = this;

		this.title = new (Class.create(chide.opts.Html, {
			label: gettext('Title'),
			changed: function(value) {
				let title = value + (that.optional && that.optional.get() ? ' <small>'+gettext('(optional)')+'</small>' : '');
				$('.title', that.element).html(that.survey.stripScriptTags(title));
			}
		}))({
			value: this.defaultTitle
		});
		this.appearance = new this.options.appearance({
			field: this,
			value: (info.children && info.children.length) ? info.children[0].appearance === 'full' : this.isTextArea
		});
	},

	serialize: function ($super) {
		return $.extend($super(), {
			idname: 'text-response'
		});
	}
});

let GuideStarSingleColumnGridField = $.klass(Fields.Natrix, {
	isGuideStar: true,
	defaultTitle: '',

	initialize: function ($super, info, editor) {
		$super(info, editor);
		let that = this;

		this.title = new (Class.create(chide.opts.Html, {
			label: gettext('Title'),
			changed: function(value) {
				let title = value + (that.optional && that.optional.get() ? ' <small>'+gettext('(optional)')+'</small>' : '');
				$('.title', that.element).html(that.survey.stripScriptTags(title));
			}
		}))({
			value: this.defaultTitle
		});
	},

	serialize: function ($super) {
		return $.extend($super(), {
			idname: 'custom-grid'
		});
	}
});


function createGuideStarTextField(identifier, name, fullName, isTextArea, parentIdentifier, depth) {
	return $.klass(GuideStarTextField, {
		guideStarDefaultMapping: identifier,
		type: identifier,
		qlass: identifier,
		cssType: identifier,
		depth: depth,
		parentIdentifier: parentIdentifier,

		displayName: name,
		defaultFullName: fullName,
		defaultTitle: fullName,
		isTextArea: isTextArea
	});
}


function createGuideStarSingleColumnGrid(identifier, name, fullName, children, parentIdentifier, depth) {
	return $.klass(GuideStarSingleColumnGridField, {
		guideStarDefaultMapping: identifier,
		type: identifier,
		qlass: identifier,
		cssType: identifier,
		depth: depth,
		parentIdentifier: parentIdentifier,

		isParent: true,
		isLastParent: !children[0].children,

		displayName: name,
		defaultFullName: fullName,
		defaultTitle: name,

		getDefaultVariables: function() {
			return children.map((field) => {
				return {
					label: field.name,
					required: false,
					type: 'string',
					guideStarDefaultMapping: identifier + '__' + field.identifier,
					isTextArea: field.isTextArea
				}
			});
		}
	});
}


function createGuideStarUIFields(arr, parentIdentifier, parentName, depth) {
	depth = depth ? depth + 1 : 1;

	return arr.reduce((newArray, field) => {
		let identifier = (parentIdentifier)
			? parentIdentifier + '__' + field.identifier
			: field.identifier;
		let fullName = (parentName)
			? parentName + ' / ' + field.name
			: field.name;

		if(field.children) {
			newArray.push(createGuideStarSingleColumnGrid(
				identifier, field.name, fullName, field.children, parentIdentifier, depth
			));
			newArray = newArray.concat(createGuideStarUIFields(
				field.children, identifier, fullName, depth
			));
		} else {
			newArray.push(createGuideStarTextField(
				identifier, field.name, fullName, field.isTextArea, parentIdentifier, depth
			));
		}

		return newArray;
	}, []);
}

let GuideStarFields = createGuideStarUIFields(guideStarSchemaTree);

let Mapping = $.klass(Option.Value, {
	label: gettext('Mapping'),

	initialize: function($super, field, config) {
		$super(field, config);
		this.subvariable = config.subvariable;
		this.set(config.value);
	},

	render: function($super) {
		let that = this;
		let $mappingSelect = $('<select class="custom-select custom-select-sm"><\/select>').css('width', '145px');
		let $searchContainer = $('<div id="search" class="sma-guidestar-mapping-option-search" style="display: none;"></div>');
		let $searchItems = $('<div id="search-items" class="sma-guidestar-mapping-option-search-items"></div>');
		let addGuideStarField = (guideStarFieldData) => {
			$mappingSelect.append($.format('<option value="{0}">{1}<\/option>', [
				guideStarFieldData.identifier, guideStarFieldData.name
			]));
			let searchItem = $($.format('<div class="add-cursor" data-value="{0}">{1}<\/div>', [
				guideStarFieldData.identifier, guideStarFieldData.name
			]));
			$searchItems.append(searchItem);
			searchItem.click((e) => {
				let value = $(e.target).data('value');
				that.set(value);
				$mappingSelect.val(value);
				$mappingSelect.change();
				$searchContainer.hide();
				that.elementSearch.clearSearch();
				that.toggleGuidestarLogo(e);
			});
		};

		$searchContainer.append($searchItems);

		addGuideStarField({
			identifier: '',
			name: gettext('None')
		});
		_.each(GuideStarFields.filter((x) => !x.prototype.isParent).map((x) => ({
				identifier: x.prototype.guideStarDefaultMapping,
				name: x.prototype.defaultFullName
			})
		), addGuideStarField);

		$mappingSelect
			.val(this.value)
			.css('margin-bottom', '0')
			.mousedown((e) => {
				e.preventDefault()
				$searchContainer.show();
				that.elementSearch.input.focus();
			})
		this.updateTypeField(this.value);

		let result = $super().addClass('col-sm-12');
		result.append("<strong class='inline'>" + this.label + "</strong>");
		result.append($mappingSelect);
		result.append($searchContainer);

		that.elementSearch = new ElementSearch({
			container: $searchItems,
			showAllOnEmpty: true
		});

		return result;
	},

	toggleGuidestarLogo: function(e) {
		// Single column grid
		if (this.subvariable) {
			if(e) {
				let target = $(e.currentTarget).closest('li');
				let index = target.index();
				let questionContainer = this.field.element.find('.variables');
				let question = $(questionContainer.find('tr')[index]);
				let guidestarLogoContainer = question.find('.sma-natrix-guidestar-container');
				let existingGuidestarLogo = question.find('.sma-guidestar-logo');
	
				let guideStarLogo = '<img width="18px" class="sma-guidestar-logo" src="' + MEDIA_URL + 'img/smapply/GuideStarLogo.svg">';

				if (existingGuidestarLogo) {
					existingGuidestarLogo.remove();
				}
	
				if (this.value) {
					guidestarLogoContainer.prepend(guideStarLogo);
				}
			}
		} else {
			let guideStarLogo = '<img width="18px" class="mr-1 sma-guidestar-logo" src="' + MEDIA_URL + 'img/smapply/GuideStarLogo.svg">';

			let container = $(this.field.element).find('.title');

			let existingGuidestarLogo = container.find('.sma-guidestar-logo');

			if (existingGuidestarLogo) {
				existingGuidestarLogo.remove();
			}

			if (this.value) {
				container.prepend(guideStarLogo);
			}
		}
	},

	changed: function(value, old) {
		this.updateTypeField(value);
	},

	updateTypeField: function(value) {
		if (this.subvariable == undefined || this.subvariable.type == undefined) {
			return;
		}
		let typeField = this.subvariable.type;

		if (value) {
			let disableMessage = gettext('Set the GuideStar mapping to "None" in order to change the type');
			block.block(typeField.input);
			$('.sma-js-switch-to-type-warning').remove();
			$(typeField.input).after(
				'<div class="sma-js-switch-to-type-warning">' +
					'<i class="nc-icon-mini ui-2_alert-circle-i"></i>' +
					'<small>&nbsp;' + disableMessage + '</small>' +
				'</div>'
			);
		} else {
			block.unblock(typeField.input);
			$('.sma-js-switch-to-type-warning').remove();
		}
	}
});


module.exports = {
	GuideStarFields,
	Mapping
}



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.fs/surveys/guidestar.js